// --- 1. Helper: Get Variant State ---
function getVariantAvailabilityState(variant) {
  if (!variant) return null;

  const dispatchDate = window.variantMetafields?.[variant.id]?.estimated_dispatch;
  const inStock = variant.inventory_quantity > 0;
  const continueSelling = variant.inventory_policy === "continue";

  if (inStock) return 1;            // In Stock
  if (!continueSelling) return 2;   // Sold Out
  if (dispatchDate) return 3;       // Preorder (Out of stock + Has Date)
  return 4;                         // Backorder (Out of stock + No Date)
}

// --- 2. UI Update: Add To Cart Button ---
function updateATCButton(variant) {
  const btn = document.querySelector("#main-atc-button");
  if (!btn) return;

  const span = btn.querySelector("span");
  const state = getVariantAvailabilityState(variant);

  // Reset basic classes first
  btn.classList.remove("disabled", "preorder");
  btn.disabled = false;

  switch (state) {
    case 1: // In-stock
      span.textContent = "Add to Cart";
      break;

    case 2: // Sold-out
      btn.disabled = true;
      btn.classList.add("disabled");
      span.textContent = "Sold Out";
      break;

    case 3: // Preorder
      btn.classList.add("preorder");
      span.textContent = "Pre Order";
      break;

    case 4: // Backorder
      span.textContent = "Add to Cart";
      break;
  }
}

// --- 3. UI Update: Warehouse & Christmas Block ---
function updateLeaveWarehouseBlock(variant, product) {
  const block = document.querySelector("#leave-warehouse-block");
  const christmasBlock = document.querySelector("#christmasDeliveryMesg");

  if (!block) return;

  const prefix = block.querySelector(".prefix");
  const msg = block.querySelector(".dispatchmessage");
  const beQuick = block.querySelector(".bequick-msg");
  const beQuickInline = block.querySelector(".bequick-inline-msg");

  const dispatch = window.variantMetafields?.[variant.id]?.estimated_dispatch;
  const state = getVariantAvailabilityState(variant);

  // A. Handle Sold Out (Hide everything)
  if (state === 2) {
    block.style.display = "none";
    if (christmasBlock) christmasBlock.style.display = "none";
    return;
  }

  block.style.display = "flex";

  // B. Handle 'Be Quick' Tag (High Priority)
  const hasBeQuick = product?.tags?.includes("change-dispatch-quick");
  beQuick.style.display = hasBeQuick ? "inline" : "none";
  beQuickInline.style.display = hasBeQuick ? "inline" : "none";

  if (hasBeQuick) {
    prefix.textContent = "";
    msg.textContent = "";
    if (christmasBlock) christmasBlock.style.display = "none";
    return;
  }

  // C. Update Message based on State
  if (state === 3) {
    prefix.textContent = "Estimated dispatch:";
    msg.textContent = dispatch;
  } else if (state === 1) {
    prefix.textContent = "Estimated delivery:";
    msg.textContent = "with you in 48 hours";
  } else if (state === 4) {
    // State 4 implies NO dispatch date exists, so we default to 48 hours immediately.
    prefix.textContent = "Estimated delivery:";
    msg.textContent = "with you in 48 hours";
  }

  // D. Christmas Logic
  if (christmasBlock) {
    // Both State 1 and State 4 result in the "48 hours" message.
    const is48HourMsg = (state === 1 || state === 4);

    if (is48HourMsg) {
      christmasBlock.innerHTML = "🎄 Arrives before <strong>Christmas</strong>";
      christmasBlock.style.display = "block";
    } else {
      christmasBlock.style.display = "none";
    }
  }
}

// --- 4. Main Update Orchestrator ---
function updateProductUI(selectedVariant) {
  const product = window.productData || window.meta?.product;
  updateATCButton(selectedVariant);
  updateLeaveWarehouseBlock(selectedVariant, product);
}

// --- 5. Logic to Find and Load Variant ---
function loadVariantById(variantId) {
  if (!variantId) return;

  const productData = window.productData || window.meta?.product;
  if (!productData) return; // Wait for data to exist

  // Find variant in JSON (ensure IDs are strings for comparison)
  const variant = productData.variants.find(v => String(v.id) === String(variantId));
  
  if (variant) {
    updateProductUI(variant);
  }
}

// --- 6. Initialization & Polling ---
document.addEventListener("DOMContentLoaded", () => {
  
  // 1. Run immediately on load (try Input, then URL, then fallback to first variant)
  const productData = window.productData || window.meta?.product;

  let initialInput = document.querySelector('input[name="id"]');
  let initialId = initialInput?.value 
    || new URLSearchParams(window.location.search).get('variant');

  // ⭐ FIX: If no variant ID is present, fall back to the first variant
  if (!initialId && productData?.variants?.length) {
    initialId = productData.variants[0].id;
  }

  if (initialId) {
    loadVariantById(initialId);
  }

  // 2. Start Polling for URL changes (SPA support)
  let lastSearch = window.location.search;

  setInterval(() => {
    // Only run logic if the URL string has actually changed
    if (window.location.search !== lastSearch) {
      lastSearch = window.location.search;
      
      const newVariantId = new URLSearchParams(lastSearch).get('variant');
      if (newVariantId) {
        loadVariantById(newVariantId);
      }
    }
  }, 1);
});